// 图片预加载工具函数
export interface PreloadProgress {
  loaded: number;
  total: number;
  percentage: number;
}

export const preloadImages = (
  urls: string[],
  onProgress?: (progress: PreloadProgress) => void,
  onComplete?: () => void,
  onError?: (failedUrls: string[]) => void
): void => {
  let loadedCount = 0;
  const totalCount = urls.length;
  const failedUrls: string[] = [];

  if (totalCount === 0) {
    onComplete?.();
    return;
  }

  urls.forEach((url) => {
    const img = new Image();
    
    img.onload = () => {
      loadedCount++;
      const percentage = Math.round((loadedCount / totalCount) * 100);
      
      onProgress?.({
        loaded: loadedCount,
        total: totalCount,
        percentage,
      });

      if (loadedCount === totalCount) {
        if (failedUrls.length > 0) {
          onError?.(failedUrls);
          // If there are failures, DO NOT call onComplete
        } else {
          onComplete?.();
        }
      }
    };

    img.onerror = () => {
      console.error(`图片加载失败: ${url}`);
      failedUrls.push(url);
      loadedCount++;
      
      const percentage = Math.round((loadedCount / totalCount) * 100);
      
      onProgress?.({
        loaded: loadedCount,
        total: totalCount,
        percentage,
      });

      if (loadedCount === totalCount) {
        if (failedUrls.length > 0) {
          onError?.(failedUrls);
          // If there are failures, DO NOT call onComplete
        } else {
          onComplete?.();
        }
      }
    };

    img.src = url;
  });
};

// 使用webpack的require.context自动收集图片
export const collectImages = (
  requireContext: any
): string[] => {
  return requireContext.keys().map(requireContext) as string[];
};
